import axios from "axios"
import { env } from "../constants"

export const list = (token, status = "active", params = {}) => {
    const uri = `${env.startpoint}bookings`
    const headers = { headers: { Authorization: `Bearer ${token}` }, params: { status, ...params } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const create = (token, data) => {
    const uri = `${env.startpoint}bookings`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(error => error.response)
}

export const get = (token, id) => {
    const uri = `${env.startpoint}bookings/${id}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const reschedule = (token, id, data) => {
    const uri = `${env.startpoint}bookings/${id}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.patch(uri, data, headers).then(response => response).catch(error => error.response)
}

export const cancel = (token, id) => {
    const uri = `${env.startpoint}bookings/${id}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.delete(uri, headers).then(response => response).catch(error => error.response)
}
